module.exports = __webpack_public_path__ + "static/media/AD.dd4d7167.svg";